import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "scenario-field-header with-elements bg-secondary text-white" }
const _hoisted_2 = { class: "float-end" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = ["disabled", "value"]
const _hoisted_6 = { class: "d-flex justify-content-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "list-group list-group-flush" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "px-2 flex-grow-1" }
const _hoisted_12 = { class: "text-body d-block" }
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "list-group-item text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.observer ? 'Observer Assignment' : 'SP Assignment') + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_modal, {
          modelValue: _ctx.modal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal) = $event))
        }, _createSlots({
          header: _withCtx(() => [
            _cache[5] || (_cache[5] = _createTextVNode("Select a User to Assign"))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("option", {
                  selected: "",
                  disabled: "",
                  hidden: ""
                }, "-- Select A User --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableUsers, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    disabled: _ctx.selectedUsers.find((i)=>i.id === item.id),
                    key: index,
                    value: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selected]
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-default mx-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = !_ctx.modal))
              }, _toDisplayString(_ctx.selectedUsers.length === _ctx.availableUsers.length ? 'Done' : 'Cancel'), 1),
              (_ctx.selectedUsers.length !== _ctx.availableUsers.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    disabled: _ctx.loading,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                    class: "btn btn-primary"
                  }, "Add", 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, [
          (_ctx.canEdit)
            ? {
                name: "trigger",
                fn: _withCtx((triggerProps) => [
                  _createElementVNode("button", {
                    onClick: triggerProps.click,
                    type: "button",
                    class: "btn slim-button btn-primary"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1),
                    _createTextVNode(" Add ")
                  ]), 8, _hoisted_3)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "list-group-item bg-white"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1),
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("small", null, _toDisplayString(item.email), 1)
                ])
              ]),
              (_ctx.canEdit)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.remove(item.id)),
                    class: "d-block text-light text-large fw-light"
                  }, "×", 8, _hoisted_14))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        (_ctx.selectedUsers.length === 0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_15, " No User Selected "))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}